import React from 'react';
import PieChart from './piechart';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatSpend = (value) => {
  if (value === undefined || value === null || value === '') {
    return 'N/A';
  }

  if (typeof value === 'number') {
    return currencyFormatter.format(value);
  }

  if (typeof value === 'string') {
    const normalized = value.replace(/[$,\s]/g, '');
    const parsed = Number(normalized);

    if (!Number.isNaN(parsed) && normalized !== '') {
      return currencyFormatter.format(parsed);
    }

    return value;
  }

  return String(value);
};

const PieChartSpending = ({ chartData, totalSpend }) => {
  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', gap: '16px', }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '6px 20px 0', boxSizing: 'border-box',
        }}
      >
        <div
          style={{ minWidth: '220px', maxWidth: '340px', width: '100%', padding: '12px 20px',
            textAlign: 'center', borderRadius: '12px',
            boxShadow: 'rgba(24, 71, 122, 0.18) 0px 8px 24px',
            background: 'linear-gradient(135deg, #f3f8ff 0%, #ffffff 100%)',
            border: '1px solid #d6e4f5',
          }}
        >
          <h4 style={{ margin: '0 0 6px 0', color: '#4b6584', letterSpacing: '0.03em' }}>Total Savings</h4>
          <div style={{ fontSize: '1.65rem', fontWeight: 700, color: '#0f3d66' }}>
            {formatSpend(totalSpend)}
          </div>
        </div>
      </div>
      <div style={{ flex: 1, minHeight: 0, }} >
        <PieChart chartData={chartData} />
      </div>
    </div>
  );
};

export default PieChartSpending;
